import { getRoleName } from '@app/utils/jwt';

import { ROLES } from '../navigation/types';

export const useIsAdmin = () => {
  return getRoleName() === ROLES.ADMIN;
};
